import { render, staticRenderFns } from "./vendor-project-details.vue?vue&type=template&id=15e8f650&scoped=true&"
import script from "./vendor-project-details.vue?vue&type=script&lang=js&"
export * from "./vendor-project-details.vue?vue&type=script&lang=js&"
import style0 from "./vendor-project-details.vue?vue&type=style&index=0&id=15e8f650&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e8f650",
  null
  
)

export default component.exports